
export const COCINERO0_API_URL = 'https://api.cocinero.app/'
